import React from "react";

import "./FinanceLayout.css";

const Finance = () => {
  return (
    <div
      className="finance-shell"
      style={{
        width: "100%",
        minHeight: "100vh",
        padding: "48px 40px",
        boxSizing: "border-box",
        fontFamily: "Segoe UI, Arial, sans-serif",
      }}
    >
      <h2 style={{ margin: "0 0 8px", color: "#0f766e", fontSize: 26 }}>
        Finance Dashboard
      </h2>
      <p style={{ margin: 0, color: "#667085", fontSize: 15 }}>
        This page is under construction.
      </p>
    </div>
  );
};

export default Finance;
